module.exports = __webpack_public_path__ + "components/rewards/insurance/static/logo-aed909b55eb1f256ad9fbc401eec366a.webp";